import { ExternalLink } from "lucide-mui";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import type { ReactNode } from "react";
import PageHeader, { type BackLink } from "../PageHeader.tsx";

interface DetailHeaderProps {
  title: ReactNode;
  back: BackLink;
  chips: ReactNode;
  sourceUrl: string | null;
  sourceLabel?: string;
  /** Right of the title, e.g. an "Open source" button in place of the inline link. */
  actions?: ReactNode;
}

/** A record page's header: back trail, title, chips and a link to the original. */
export default function DetailHeader({
  title,
  back,
  chips,
  sourceUrl,
  sourceLabel = "View source",
  actions,
}: DetailHeaderProps) {
  return (
    <PageHeader
      back={back}
      title={title}
      actions={actions}
      description={
        <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: "wrap", alignItems: "center", mt: 0.25 }}>
          {chips}
          {sourceUrl && (
            <Link
              href={sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, fontSize: "0.875rem" }}
            >
              {sourceLabel} <ExternalLink fontSize="inherit" />
            </Link>
          )}
        </Stack>
      }
    />
  );
}
